import React, { useEffect, useState } from "react";
import { Button, FloatingLabel, Form, InputGroup } from "react-bootstrap";
import "./AjoutCours.css";
import { useForm } from "react-hook-form";
import { db, forNotification, getDocument } from "../../../Firebase";
import { toast } from "react-toastify";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import { useNavigate, useHistory, Link } from "react-router-dom";

function AjoutCours() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const [userCurrent, setUserCurrent] = useState({});
  const userId = sessionStorage.getItem("user_id");
  useEffect(() => {
    getDocument("users", userId, setUserCurrent);
  }, [userId])

  const onSubmit = (data) => {
    const { titre_cours } = data
    try {
      const docRef = addDoc(collection(db, "cours"), {
        ...data,
        admin_id: userCurrent.user_type === "admin" ? userCurrent.my_id : userCurrent.admin_id,
        isArchived: false,
        isApproved: userCurrent.user_type === "admin" ? true : false,
        domaine: userCurrent.user_type === "admin" ? data.domaine : userCurrent.domaine,

        created_on: Timestamp.fromDate(new Date()),
        created_by: userCurrent.my_id,
        etudiants: [],
        infoUser: `${userCurrent.nom} ${userCurrent.prenom}`
      }).then(
        userCurrent.user_type === 'prof' ? forNotification(`a ajouter un cours dont le titre est ${titre_cours} merci de l'approuver ou de rejeter`, userCurrent.admin_id) : null
      )
      toast.success("Ajouter avec success !")
      reset()
      navigate(-1)
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }

  return (
    <div className="ajout-cours  ">
      <h5>Ajouter un nouveau cours</h5>
      <p>Il suffit de remplir le formulaire et de créer vos cours.</p>
      <hr></hr>
      <div className="cont-ajout-cours">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mt-4 my-2" controlId="formBasicTitre">
            <Form.Label>Titre du cours</Form.Label>
            <Form.Control
              className="py-2"
              type="text"
              placeholder="Titre du cours"
              {...register("titre_cours", {
                required: true,
                maxLength: 30
              })}
            />
            {errors?.titre_cours?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
            {errors?.titre_cours?.type === "maxLength" && (
              <p className="text-danger">La longueur maximal est de 30 lettres</p>
            )}
            <Form.Text id="passwordHelpBlock" muted>
              Rédigez un titre de cours de 30 caractères.
            </Form.Text>
          </Form.Group>
          {
            userCurrent.user_type === "admin" ?
              <Form.Group className="my-3" controlId="formBasicCategories">
                <Form.Label>catégories de cours</Form.Label>
                <Form.Select {...register("domaine", { required: true })}>
                  <option value="Gestion de projet">Gestion de projet</option>
                  <option value="Programmation">Programmation</option>
                  <option value="Design">Design</option>
                  <option value="Marketing Digital">Marketing Digital</option>
                </Form.Select>
                {errors?.domaine?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                <Form.Text id="passwordHelpBlock" muted>
                  Aidez les gens à trouver vos cours en choisissant des catégories
                  qui représentent votre cours.
                </Form.Text>
              </Form.Group> : null
          }
          <Form.Group className="my-3" controlId="formBasicDescription">
            <Form.Label>Description du cours</Form.Label>
            <FloatingLabel className=" " controlId="floatingTextarea2">
              <Form.Control
                as="textarea"
                placeholder="Entrer votre description ici"
                style={{ minHeight: "100px", maxHeight: "500px" }}
                {...register("description", { required: true })}
              />
            </FloatingLabel>
            {errors?.description?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
            <Form.Text id="passwordHelpBlock" muted>
              Un bref résumé de vos cours.
            </Form.Text>
          </Form.Group>

          <Form.Group controlId="coursLink" className="my-3">
            <Form.Label className="" htmlFor="basic-url">
              Entrez une URL de vidéo valide
            </Form.Label>
            <InputGroup>
              <InputGroup.Text id="inputCoursLink">
                https://example.com/users/
              </InputGroup.Text>
              <Form.Control
                id="basic-url"
                aria-describedby="inputCoursLink"
                {...register("lien_cours", { required: true })}
                type='url'
              />
            </InputGroup>
            {errors?.lien_cours?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
            <Form.Text id="coursLinkHelpBlock" muted>
              Entrer le lien de la play liste youtube ou vimeo de votre Cours
            </Form.Text>
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button onClick={() => navigate(-1)} variant="danger">Annuler </Button>
            <Button type="submit" className="ms-2" variant="outline-success">
              Envoyer
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default AjoutCours;
